import { Box, Button, Container, Stack, Typography, useTheme } from '@mui/material';
import { Link } from 'react-router-dom';
import { useLanguage, useT } from '../../i18n';

const NAV_LINKS = [
  { id: 'fitur', key: 'landing.nav.features' },
  { id: 'pengelola', key: 'landing.nav.management' },
  { id: 'warga', key: 'landing.nav.residents' },
  { id: 'kontak', key: 'landing.nav.contact' },
] as const;

export function Brand() {
  return (
    <Stack direction="row" spacing={1} alignItems="center">
      <Box
        component="img"
        src="/logo.png"
        alt=""
        aria-hidden
        sx={{ width: 28, height: 28, borderRadius: 1.5 }}
      />
      <Typography variant="h6" fontWeight={600} sx={{ letterSpacing: '-0.2px' }}>
        LivinHome
      </Typography>
    </Stack>
  );
}

export function LandingNav() {
  const t = useT();
  const theme = useTheme();
  const { lang, setLang } = useLanguage();

  return (
    <Box
      component="header"
      sx={{
        position: 'sticky',
        top: 0,
        zIndex: 10,
        bgcolor: 'background.default',
        borderBottom: `1px solid ${theme.palette.divider}`,
      }}
    >
      <Container
        maxWidth="lg"
        sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', py: 1.5 }}
      >
        <Brand />
        <Stack direction="row" spacing={{ xs: 1.5, md: 3 }} alignItems="center">
          <Stack direction="row" spacing={3} sx={{ display: { xs: 'none', md: 'flex' } }}>
            {NAV_LINKS.map((l) => (
              <Typography
                key={l.id}
                component="a"
                href={`#${l.id}`}
                variant="body2"
                sx={{
                  color: 'text.secondary',
                  textDecoration: 'none',
                  '&:hover': { color: 'text.primary' },
                }}
              >
                {t(l.key)}
              </Typography>
            ))}
          </Stack>
          <Button
            size="small"
            color="inherit"
            onClick={() => setLang(lang === 'id' ? 'en' : 'id')}
            sx={{ color: 'text.secondary', minWidth: 0, px: 1 }}
            aria-label="Switch language"
          >
            {lang === 'id' ? 'EN' : 'ID'}
          </Button>
          <Button size="small" variant="contained" color="primary" component={Link} to="/login">
            {t('landing.nav.login')}
          </Button>
        </Stack>
      </Container>
    </Box>
  );
}
